import { getUrlParamsByObject } from 'Utils/url';
import { httpClientFarm } from './microservice-http-clients';

export const getList = (limit, s) => httpClientFarm.get(`/${getUrlParamsByObject({ limit, s })}`);
export const getFarmData = slug => httpClientFarm.get(`/${slug}`);
export const getClosedSuccessfullyList = (limit, s) => httpClientFarm.get(`/closed${getUrlParamsByObject({ limit, s })}`);
